import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CompanyDTO, TargetingDTO, TargetingType, TimingRelation } from '../../../services/api/api';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from '../../../services/user.service';
import { CompaniesComponent } from '../../company/companies/companies.component';
import { ModalService } from '../../../services/gui/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { Mutable } from '../../../services/global/global-interfaces';
import { enumKeys } from 'src/app/services/global/global-methods';

@Component({
  selector: 'sb-page-targeting-edit',
  templateUrl: './targeting-edit.component.html',
  styleUrls: ['./targeting-edit.component.scss'],
  standalone: false,
})
export class TargetingEditComponent implements OnInit {
  @Input() targeting: Mutable<TargetingDTO>;
  @Output() editTargeting: EventEmitter<TargetingDTO>;

  formTargeting: UntypedFormGroup;

  timingRelations: TimingRelation[];
  targetingTypes: TargetingType[];

  constructor(
    private userService: UserService,
    private modal: ModalService,
    public translate: TranslateService
  ) {
    this.editTargeting = new EventEmitter<TargetingDTO>();
    this.formTargeting = new UntypedFormGroup({
      Name: new UntypedFormControl('', Validators.required),
      Description: new UntypedFormControl('', []),
      Amount: new UntypedFormControl({ value: undefined }, Validators.required),
      Target: new UntypedFormControl(TargetingType.Impressions, Validators.required),
      Relation: new UntypedFormControl(TimingRelation.WholePeriod, Validators.required),
    });

    this.timingRelations = [];
    this.targetingTypes = [];
  }

  ngOnInit(): void {
    this.initEnums();
    this.registerFormChangesListener();
    if (this.targeting) {
      this.Name.setValue(this.targeting.name);
      this.Description.setValue(this.targeting.description);
      if (this.targeting.target) {
        this.TargetingTarget.setValue(this.targeting.target);
        this.TargetingTarget.markAsTouched();
      } else if (this.targetingTypes[0]) {
        this.targeting.target = this.targetingTypes[0];
        this.TargetingTarget.markAsTouched();
      }

      if (this.targeting.relation) {
        this.TargetingRelation.setValue(this.targeting.relation);
        this.TargetingRelation.markAsTouched();
      } else if (this.timingRelations[0]) {
        this.targeting.relation = this.timingRelations[0];
        this.TargetingRelation.markAsTouched();
      }
      this.TargetingAmount.setValue(this.targeting.amount);
      this.targeting.customer = this.userService.user.client.primaryCompany;
    }
  }

  initEnums() {
    const timingKeys = enumKeys(TimingRelation);
    this.timingRelations = [];
    for (const val of timingKeys) {
      this.timingRelations.push(TimingRelation[val]);
    }

    const targetingKeys = enumKeys(TargetingType);
    this.targetingTypes = [];
    for (const val of targetingKeys) {
      this.targetingTypes.push(TargetingType[val]);
    }
  }

  get TargetingAmount() {
    return this.formTargeting.get('Amount');
  }

  get Name() {
    return this.formTargeting.get('Name');
  }

  get Description() {
    return this.formTargeting.get('Description');
  }

  get TargetingTarget() {
    return this.formTargeting.get('Target');
  }

  get TargetingRelation() {
    return this.formTargeting.get('Relation');
  }

  selectCompany() {
    this.modal
      .showNavigationModal({
        entryComponent: { value: CompaniesComponent, data: {} },
        title: null,
        modalOptions: { windowClass: 'bigXL' },
      })
      .then((result: CompanyDTO) => {
        if (result) {
          this.targeting.customer = result;
        } else {
          this.targeting.customer = null;
        }
      })
      .catch(() => {});
  }

  private registerFormChangesListener() {
    this.Name.valueChanges.subscribe(value => {
      if (this.targeting) {
        this.targeting.name = value;
      }
    });
    this.Description.valueChanges.subscribe(value => {
      if (this.targeting) {
        this.targeting.description = value;
      }
    });
    this.TargetingAmount.valueChanges.subscribe(value => {
      if (this.targeting) {
        this.targeting.amount = value;
      }
    });
    this.TargetingRelation.valueChanges.subscribe(value => {
      if (this.targeting) {
        this.targeting.relation = value;
      }
    });
    this.TargetingTarget.valueChanges.subscribe(value => {
      if (this.targeting) {
        this.targeting.target = value;
      }
    });
  }
}
